import { useMemo } from "react";
import { useTypedSelector } from "../../../../../store/reducers/use-typed-selector";
import { TemplateClassNames } from "../../../../../types/template-layouts";
import { PageModuleGroupModules, PageModuleType, SessionTabsLayoutTypes } from "../../../../../types/working-model";
import { replaceSpaceWithDash } from "../../../../../utils/utils";
import { ModuleMap } from "./editor-main";

interface IRenderModulesProps {
	groupUuid: string
}

const RenderModules: React.FC<IRenderModulesProps> = ({ groupUuid }) => {
	const {
		CreateSessionReducer: {
			workingSession,
		},
		CreateEventReducer: {
			workingEvent
		}
	} = useTypedSelector(state => state);

	const templateName = workingEvent?.template?.name;
	const modules = useMemo(() => {
		const moduleGroup = workingSession?.module_grouping?.find((moduleGroup: PageModuleGroupModules) => {
			return (moduleGroup.uuid === groupUuid);
		});

		return moduleGroup?.modules.map(moduleId => {
			const module = workingSession?.modules.find(module => module.id === moduleId);
			const tabLayout = replaceSpaceWithDash(workingSession?.layout?.tabs?.layout.toLowerCase() || SessionTabsLayoutTypes.Horizontal.toLowerCase());

			if (!module || !module.is_on || !moduleGroup.is_on) return null;

			// FUTURE DEV - hiding quizzes
			if (module.type === PageModuleType.quizzes) return null;

			const Module = ModuleMap[module.type];

			//isSession is for Blank module
			return <Module key={module.id} page_module={module} template={TemplateClassNames[templateName || 'Apollo']} tabLayout={tabLayout} isSession />;
		});

	}, [workingSession, groupUuid, templateName]);

	return (
		<div className="session-modules-container">{modules}</div>
	);
};

export default RenderModules;
